module.exports = __webpack_public_path__ + "static/media/talo-sinisen-taivaan-alla.21d541cd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/talo-sinisen-taivaan-alla.jpg
 ** module id = 414
 ** module chunks = 0
 **/